// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-form-Select-style__wrapper_Qo9th","select":"src-modules-form-Select-style__select_wwFBW","grey":"src-modules-form-Select-style__grey_LXusR"};